<template>
    <card class="stacked-form" title="Stacked Form">
        <h4 slot="header" class="card-title">Editeaza Profil</h4>
        <form @submit.prevent>
            <base-input disabled v-model="user.email" label="Email" type="email" placeholder="Email"/>
            <base-input v-model="user.name" label="Nume" placeholder="Nume"/>
            <base-button @click="updateProfile()" class="mt-3" native-type="submit" type="primary">Salveaza
            </base-button>
        </form>
        <div>
        </div>
    </card>
</template>

<script>
    import axios from 'axios';

    export default {
        data() {
            return {
                user: {
                    name: "",
                    email: ""
                }
            }
        },
        mounted() {
            this.getData();
        },
        methods: {
            getData() {
                axios.post('/auth/me')
                    .then(res => {
                        this.user = res.data;
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            updateProfile() {
                if (this.user.name === "") {
                    this.$notify({
                        type: "danger",
                        icon: 'tim-icons icon-bell-55',
                        message: "Campul 'Nume' este gol!",
                    });
                    return;
                }
                axios.post('profile/update', this.user)
                    .then(res => {
                        this.notifySuccess();
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            notifySuccess() {
                this.$notify({
                    type: 'success',
                    message: 'Modificarile au fost salvate cu succes',
                    icon: 'tim-icons icon-bell-55',
                })
            }
        }
    }
</script>